const InsuranceChallenge1Dataset = {
    
        items: {
           
            "item-1": { id: "item-1", content: "A visitor slips on your icy front steps and gets injured.", 
                    answer: "column-3" },
            "item-2": { id: "item-2", content: "A tree falls on your car while it's parked in your driveway.", 
                    answer: "column-2"},
            "item-3": { id: "item-3", content: "Your laptop is stolen from your car.", 
                    answer: "column-3" },
            "item-4": { id: "item-4", content: "You bet a friend $50 on a game and lose.",
                    answer: "column-5" },
            "item-5": { id: "item-5", content: "You need mental health counseling sessions.",
                    answer: "column-4" },
            "item-6": { id: "item-6", content: "A windstorm blows out your living room window " +
                    "and damages your furniture. ",
                    answer: "column-3" },
            "item-7": { id: "item-7", content: "You live in an apartment and the exterior " +
                    "of the building is damaged by a hail storm.",
                    answer: "column-5"},
            "item-8": { id: "item-8", content: "You sprain your ankle playing basketball and need an X-ray.",
                    answer: "column-4"},
            "item-9": { id: "item-9", content: "You lend your car to a friend and they get into " +
                    "an accident. ",
                    answer: "column-2"},
            "item-10": {id: "item-10", content: "Your car is parked on the street overnight and " +
                    "someone keys the entire side of it.",
                    answer: "column-2"}   
        },
        columns: {
            "column-1": { id: "column-1", title: "Situations/Scenarios", 
                itemIds: ['item-1', 'item-2', 'item-3', "item-4", "item-5", "item-6",
                    "item-7", "item-8", "item-9", "item-10"  ] },
            "column-2": { id: "column-2", title: "Automobile Insurance", itemIds: [] },
            "column-3": { id: "column-3", title: "Apartment/Home Insurance", itemIds: [] },
            "column-4": { id: "column-4", title: "Health Insurance", itemIds: [] },
            "column-5": { id: "column-5", title: "Not Covered By Your Insurance", itemIds: [] },
                  
        },
        columnOrder: ["column-1", "column-2", "column-3", "column-4", "column-5"]
    }

export default InsuranceChallenge1Dataset